<template>
  <div class="share-wrap no-px2rem">
    <div v-if="title" class="share-icons-title">{{title}}</div>
    <section class="share">
      <div class="icons" :class="{'ipad-icons': isIPad}">
        <div class="icon" @click.stop="plantformClick(plantform)" v-for="plantform in plantforms" :key="plantform.name">
          <img :src="plantform.icon" />
        </div>
        <div class="icon" @click.stop="systemEntrance">
          <img :src="moreIconUrl" />
        </div>
      </div>
    </section>
    <LoadingMask v-show="loading"></LoadingMask>
  </div>
</template>
<script>
  import LoadingMask from '@/components/loading/loading-mask'
  import { PLATFORM_ICON_MAP, PLATFORM_BRIDGE_METHOD } from './platformConfig'
  import { getShortLink } from '@/common/js/utils.js'
  const moreIconUrl = 'https://img0.didiglobal.com/static/soda_static/m/act/static/img/more@2x.png'

  export default {
    components: { LoadingMask },
    props: {
      config: {
        type: Object,
        default: () => {}
      },
      shortLink: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        loading: false,
        moreIconUrl
      }
    },
    computed: {
      plantforms () {
        const { config } = this.config
        const { order } = this.config
        let res = Object.entries(config)
          .filter(conf => {
            let [key] = conf
            return order.includes(key)
          })
          .map(conf => {
            let [key, value] = conf
            return {
              name: order.includes(key) ? key : '',
              icon: PLATFORM_ICON_MAP[key] || '',
              bridge: PLATFORM_BRIDGE_METHOD[key] || '',
              config: value
            }
          })
        return res
      }
    },
    methods: {
      plantformClick (plantform) {
        const { name = '' } = plantform
        this.$emit('handle-click-track', name.toLowerCase())
        let config = plantform.config || this.config.config.common
        this.shareCommon(name.toLowerCase(), plantform.bridge, config)
      },
      async systemEntrance () {
        this.$emit('handle-click-track', 'systemEntrance')
        let config = this.config.config.systemEntrance || this.config.config.common
        await this.shareCommon('systemEntrance', 'shareSystemEntrance', config)
      },
      async sms () {
        let config = this.config.config.sms || this.config.config.common
        await this.shareCommon('sms', 'shareSMS', config)
      },
      async email () {
        let config = this.config.config.email || this.config.config.common
        await this.shareCommon('email', 'shareEmail', config)
      },
      async shareCommon (plantform, bridgMethod, config) {
        this.$emit('trackShareClick', plantform)
        let shareConfig = {...config}
        shareConfig.url += `&sharePlatform=${plantform}`
        if (this.shortLink) {
          this.loading = true
          shareConfig.url = await getShortLink(shareConfig.url)
          this.loading = false
        }
        // 分享whatsapp、facebook、Mycenter、调面板都不支持回调, 不做回调处理
        await this.SodaBridge(bridgMethod, {
          url: shareConfig.url,
          title: shareConfig.title,
          content: shareConfig.content,
          icon: shareConfig.icon
        })
      }
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
$conversion = 0.5859375px
  .share-wrap.no-px2rem
    .share
      .icons
        padding 0 15px 15px
        font-size 12px
        display flex
        justify-content center
        flex-wrap wrap
        &.morethan
          .icon
            margin-left 29px
        .icon
          padding-top 15px
          margin-left 35px
          img
            width 36px
            height 36px
        .icon:first-child
          margin-left 0
      .ipad-icons
        padding 0 15px
.share-icons-title {
  font-family: DiDiSans-Pro-Bold;
  font-size: 56px;
  color: #000;
  letter-spacing: 0;
  line-height: 56px;
  margin-bottom: 50px;
}
</style>
